// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3002":"44c591a1","4149":"093a4eed"}[chunkId] + ".chunk.css";
};